// extracted by mini-css-extract-plugin
export default {"navBarMargin":"Footer_navBarMargin__3EXU3","font":"Footer_font__L1ver","bitsCopyright":"Footer_bitsCopyright__lyZg1","footer":"Footer_footer__AcWGP"};